import { useToast } from '../view/hooks'

const { showToast } = useToast()

export const CatchMessageError = async (data: any) => {
  const error = data?.response?.data?.errors[0] || 'Falha ao realizar a operação'
  showToast(error, 'error')
}
